var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "productQuotationApplicationAdd container" },
    [
      _c(
        "el-row",
        [
          _c(
            "el-button",
            {
              staticClass: "btn",
              attrs: { size: "mini", type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.$router.go(-1)
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("common.close")))]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "applyProductTableDataRef",
          staticStyle: { "margin-top": "5px" },
          attrs: {
            data: _vm.tableDetail,
            border: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              sortable: "",
              prop: "sourcingNo",
              label: "定点单据编号",
              "min-width": "140px",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm.emplFlag == "MCD"
                      ? _c(
                          "el-link",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.openQuotationApplyDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(scope.row.sourcingNo) + " ")]
                        )
                      : _vm._e(),
                    _vm.emplFlag != "MCD"
                      ? _c("span", [_vm._v(_vm._s(scope.row.sourcingNo))])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              sortable: "",
              prop: "tmSupplierId",
              label: "线路承运商",
              "min-width": "120px",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("ic")(
                            scope.row.tmSupplierId,
                            "BASE",
                            "CARRIER"
                          )
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              sortable: "",
              prop: "eightBitCode",
              label: "8位码",
              "min-width": "130px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              sortable: "",
              prop: "productPrice",
              label: "产品运费（不含税）",
              "min-width": "100px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              sortable: "",
              prop: "effectiveBeginDate",
              label: "产品有效开始日期",
              width: "200",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(
                        _vm._f("dateFormatFilter")(
                          scope.row.effectiveBeginDate,
                          "YYYY-MM-DD"
                        )
                      )
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              sortable: "",
              prop: "isSpecialFreight",
              label: "非标准线路运费",
              "min-width": "150px",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("ic")(
                            scope.row.isSpecialFreight,
                            "COMMON",
                            "YES_NO"
                          )
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              sortable: "",
              prop: "remarks",
              label: _vm.$t("common.remarks"),
              "min-width": "100px",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }